export interface IIconInfo {
  url: string;
  anchor?: null | { x: number, y: number };
  shape?: null | { coords: number[], type: string };
  shouldRotate?: null | boolean;
  scaledSize?: { width: number, height: number };
  labelOrigin?: any;
}

export interface IIconsHash {
  'asset-stationary': IIconInfo;
  'asset-stationary-selected': IIconInfo;
  'asset-motion': IIconInfo;
  'vehicle': IIconInfo;
  'interrupted': IIconInfo;
  'reconnect': IIconInfo;
  'selected-vehicle': IIconInfo;
  'location-on_duty': IIconInfo;
  'location-on_duty-disabled': IIconInfo;
  'dashcam_generic_event': IIconInfo;
  'hard_accel': IIconInfo;
  'hard_accel-disabled': IIconInfo;
  'selected-hard_accel': IIconInfo;
  'hard_brake': IIconInfo;
  'hard_brake-disabled': IIconInfo;
  'selected-hard_brake': IIconInfo;
  'hard_corner': IIconInfo;
  'hard_corner-disabled': IIconInfo;
  'selected-hard_corner': IIconInfo;
  'requested_video': IIconInfo;
  'requested_video-disabled': IIconInfo;
  'selected-requested_video': IIconInfo;
  'marker-driving-eld-enabled': IIconInfo;
  'arrow-head': IIconInfo;
  'marker-driving-eld-enabled-glow': IIconInfo;
  'driver-on-duty': IIconInfo;
  'shipper-facility': IIconInfo;
  'selected-shipper-facility': IIconInfo;
  'vehicle-stationary': IIconInfo;
  'driving-without-eld': IIconInfo;
  'circle-head': IIconInfo;
  'vehicle-idle': IIconInfo;
  'vehicle-off': IIconInfo;
  'arrow-driving': IIconInfo;
  'off-duty': IIconInfo;
  'vehicle-error': IIconInfo;
  'circle-driving': IIconInfo;
  'dispatch-picked': IIconInfo;
  'dispatch-picking': IIconInfo;
  'dispatch-to-pick': IIconInfo;
  'dispatch-unknown': IIconInfo;
  'posted': IIconInfo;
  'alert': IIconInfo;
  'live-image': IIconInfo;
  'transaction': IIconInfo;
  'incabAlert': IIconInfo;
  'incabAlertHover': IIconInfo;
  'incabAlertGraph': IIconInfo;
  'incabAlertGraphHover': IIconInfo;
}

export const ICONS: IIconsHash = {

  'asset-stationary': {
    url: require('../images/map/asset-stationary.png'),
    anchor: { x: 13, y: 13 },
    scaledSize: { width: 26, height: 26 },
  },

  'asset-stationary-selected': {
    url: require('../images/map/asset-stationary-selected.png'),
    anchor: { x: 13, y: 13 },
    scaledSize: { width: 26, height: 26 },
  },

  'asset-motion': {
    url: require('../images/map/asset-motion.png'),
    anchor: { x: 15, y: 15 },
    shouldRotate: true,
    shape: {
      coords: [24, 7, 8, 23],
      type: 'rect',
    },
  },

  'vehicle': {
    url: require('../images/map/marker-vehicle.png'),
    scaledSize: { width: 48, height: 48 },
    anchor: { x: 24, y: 24 },
  },

  'interrupted': {
    url: require('../images/map/interrupted.png'),
    scaledSize: { width: 48, height: 48 },
    anchor: { x: 24, y: 24 },
  },

  'reconnect': {
    url: require('../images/map/reconnect.png'),
    scaledSize: { width: 48, height: 48 },
    anchor: { x: 24, y: 24 },
  },

  'selected-vehicle': {
    url: require('../images/map/marker-selected-vehicle.png'),
    scaledSize: { width: 48, height: 48 },
    anchor: { x: 24, y: 24 },
  },

  'location-on_duty': {
    url: require('../images/map/marker-on-duty.png'),
    scaledSize: { width: 16, height: 16 },
    anchor: { x: 8, y: 8 },
  },

  'location-on_duty-disabled': {
    url: require('../images/map/marker-on-duty-disabled.png'),
    scaledSize: { width: 16, height: 16 },
    anchor: { x: 8, y: 8 },
  },

  'dashcam_generic_event': {
    url: require('../images/map/dashcam-generic.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'hard_accel': {
    url: require('../images/map/marker-acceleration.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'hard_accel-disabled': {
    url: require('../images/map/marker-acceleration-disabled.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'selected-hard_accel': {
    url: require('../images/map/marker-acceleration-focus.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'hard_brake': {
    url: require('../images/map/marker-brake.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'hard_brake-disabled': {
    url: require('../images/map/marker-brake-disabled.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'selected-hard_brake': {
    url: require('../images/map/marker-brake-focus.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'hard_corner': {
    url: require('../images/map/marker-corner.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'hard_corner-disabled': {
    url: require('../images/map/marker-corner-disabled.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'selected-hard_corner': {
    url: require('../images/map/marker-corner-focus.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'requested_video': {
    url: require('../images/map/marker-requested-video.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'requested_video-disabled': {
    url: require('../images/map/marker-requested-video-disabled.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'selected-requested_video': {
    url: require('../images/map/marker-requested-video-focus.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'marker-driving-eld-enabled': {
    url: require('../images/map/marker-driving-eld-enabled.png'),
    anchor: { x: 62, y: 20 },
    shouldRotate: true,
    shape: {
      coords: [60, 18, 13],
      type: 'circle',
    },
  },

  'arrow-head': {
    url: require('../images/map/arrow-head.png'),
    shouldRotate: true,
    anchor: { x: 20, y: 20 },
    shape: {
      coords: [4, 36, 37, 2],
      type: 'circle',
    },
  },

  'marker-driving-eld-enabled-glow': {
    url: require('../images/map/marker-driving-eld-enabled-glow.png'),
    anchor: { x: 62, y: 20 },
    shouldRotate: true,
    shape: {
      coords: [60, 18, 13],
      type: 'circle',
    },
  },

  'driver-on-duty': {
    url: require('../images/map/driver-on-duty.png'),
    anchor: { x: 62, y: 20 },
    shape: {
      coords: [64, 20, 8],
      type: 'circle',
    },
  },
  'shipper-facility': {
    url: require('../images/map/marker-shipper-facility.png'),
    anchor: { x: 62, y: 20 },
    shape: {
      coords: [83, 33, 20],
      type: 'circle',
    },
  },

  'selected-shipper-facility': {
    url: require('../images/map/marker-selected-shipper-facility.png'),
    anchor: { x: 62, y: 20 },
    shape: {
      coords: [83, 33, 20],
      type: 'circle',
    },
  },

  'vehicle-stationary': {
    url: require('../images/map/driver-on-duty.png'),
    anchor: { x: 62, y: 20 },
    shape: {
      coords: [64, 20, 8],
      type: 'circle',
    },
  },

  'driving-without-eld': {
    url: require('../images/map/driving-without-eld.png'),
    anchor: { x: 62, y: 20 },
    shape: {
      coords: [64, 20, 8],
      type: 'circle',
    },
  },

  'circle-head': {
    url: require('../images/map/circle-head.png'),
    anchor: { x: 13, y: 13 },
    scaledSize: { width: 26, height: 26 },
  },

  'vehicle-idle': {
    url: require('../images/map/vehicle-idle.png'),
    anchor: { x: 13, y: 13 },
    scaledSize: { width: 26, height: 26 },
  },

  'vehicle-off': {
    url: require('../images/map/vehicle-off.png'),
    anchor: { x: 13, y: 13 },
    scaledSize: { width: 26, height: 26 },
  },

  'arrow-driving': {
    url: require('../images/map/arrow-driving.png'),
    anchor: { x: 16, y: 16 },
    shouldRotate: true,
    shape: {
      coords: [11, 13, 23, 21],
      type: 'rect',
    },
  },

  'off-duty': {
    url: require('../images/map/off-duty.png'),
    anchor: { x: 62, y: 20 },
    shape: {
      coords: [64, 20, 8],
      type: 'circle',
    },
  },

  'vehicle-error': {
    url: require('../images/map/vehicle-error.png'),
  },

  'circle-driving': {
    url: require('../images/map/circle-driving.png'),
    anchor: { x: 4, y: 4 },
  },

  'dispatch-picked': {
    url: require('../images/map/dispatch-picked.png'),
    anchor: { x: 29, y: 58 },
    scaledSize: { width: 48, height: 58 },
    labelOrigin: { x: 24, y: 20 },
  },

  'dispatch-picking': {
    url: require('../images/map/dispatch-picking.png'),
    anchor: { x: 24, y: 57 },
    scaledSize: { width: 48, height: 73 },
    labelOrigin: { x: 24, y: 20 },
  },

  'dispatch-to-pick': {
    url: require('../images/map/dispatch-to-pick.png'),
    anchor: { x: 24, y: 52 },
    scaledSize: { width: 48, height: 58 },
    labelOrigin: { x: 24, y: 20 },
  },

  'dispatch-unknown': {
    url: require('../images/map/dispatch-unknown.png'),
    anchor: { x: 16, y: 16 },
    scaledSize: { width: 32, height: 32 },
  },

  'posted': {
    url: require('../images/map/marker-speeding.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 12 },
  },

  'alert': {
    url: require('../images/map/marker-alert.png'),
    scaledSize: { width: 20, height: 20 },
    anchor: { x: 10, y: 10 },
  },

  'live-image': {
    url: require('../images/map/live-image-marker.png'),
    scaledSize: { width: 8, height: 8 },
    anchor: { x: 10, y: 10 },
  },

  'transaction': {
    url: require('../images/map/transaction.png'),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 10, y: 10 },
  },

  'incabAlert': {
    url: require('../images/map/incab-alert.png'),
    scaledSize: { width: 32, height: 32 },
    anchor: { x: 16, y: 16 },
  },

  'incabAlertHover': {
    url: require('../images/map/incab-alert-hover.png'),
    scaledSize: { width: 60, height: 60 },
    anchor: { x: 30, y: 30 },
  },

  'incabAlertGraph': {
    url: require('../images/map/incab-alert-graph.png'),
    scaledSize: { width: 22, height: 22 },
    anchor: { x: 11, y: 11 },
  },

  'incabAlertGraphHover': {
    url: require('../images/map/incab-alert-graph-hover.png'),
    scaledSize: { width: 40, height: 40 },
    anchor: { x: 20, y: 20 },
  },
};
